import useStore from '../Store/market_greeks_data_store';

export const customIndicatorsGetter = function (PineJS) {
  return Promise.resolve([
    {
      name: 'SPX Gamma Volatility Indicator',
      metainfo: {
        _metainfoVersion: 53,
        id: "SPXGammaVolatilityIndicator@tv-basicstudies-1", // keep your ID
        description: "SPX Gamma Volatility Indicator",
        shortDescription: "SPX Gamma Vol",
        format: { type: "inherit" },
        linkedToSeries: false,
        is_price_study: false,

        // Order matters: background → foreground
        plots: [
          // Glows
          { id: "avg_glow",  type: "line", title: "Avg Glow" },
          { id: "smooth_glow", type: "line", title: "Smooth Glow" },

          // Your existing lines (keep IDs/names)
          { id: "avg_z_score_plot", type: "line", title: "VVIX Avg Z-Score" },
          { id: "super_smooth_z_score_plot", type: "line", title: "VVIX Super Smooth Z-Score" },

          // Baseline (for fills)
          { id: "baseline", type: "line" },

          // Haze sources (very faint area to baseline)
          { id: "avg_area_src", type: "line" },
          { id: "smooth_area_src", type: "line" },

          // Crossover halo band (top/bottom)
          { id: "halo_top", type: "line" },
          { id: "halo_bot", type: "line" },

          // Ambient zone bands
          { id: "zone_pos_hi", type: "line" }, // +1.0
          { id: "zone_pos_lo", type: "line" }, // +0.5
          { id: "zone_neg_hi", type: "line" }, // -0.5
          { id: "zone_neg_lo", type: "line" }, // -1.0
        ],

        // Fills
        filledAreas: [
          // Haze (single-color gradient effect via transparency)
          { id: "fa_avg",   objAId: "avg_area_src",   objBId: "baseline", type: "plot_plot", title: "Avg Haze",   fillToIntersection: true },
          { id: "fa_smooth",objAId: "smooth_area_src",objBId: "baseline", type: "plot_plot", title: "Smooth Haze",fillToIntersection: true },

          // Crossover halo
          { id: "fa_halo",  objAId: "halo_top", objBId: "halo_bot", type: "plot_plot", title: "Crossover Halo", fillToIntersection: true },

          // Ambient zones
          { id: "fa_zone_pos", objAId: "zone_pos_hi", objBId: "zone_pos_lo", type: "plot_plot", title: "Zone +", fillToIntersection: true },
          { id: "fa_zone_neg", objAId: "zone_neg_lo", objBId: "zone_neg_hi", type: "plot_plot", title: "Zone -", fillToIntersection: true },
        ],

        defaults: {
          styles: {
            // Big, soft neon glows
            avg_glow:      { plottype: 0, linewidth: 6, linestyle: 0, transparency: 80, color: "#35ff9e", visible: true },
            smooth_glow:   { plottype: 0, linewidth: 6, linestyle: 0, transparency: 80, color: "#ff3b3b", visible: true },

            // Main lines (kept as lines, just brighter colors)
            avg_z_score_plot: {
              linestyle: 0, linewidth: 2, plottype: 0, trackPrice: false,
              transparency: 0, visible: true, color: "#35ff9e",
            },
            super_smooth_z_score_plot: {
              linestyle: 0, linewidth: 2, plottype: 0, trackPrice: false,
              transparency: 0, visible: true, color: "#ff3b3b",
            },

            // Baseline hidden; halo handles seam
            baseline:        { plottype: 0, linewidth: 0, linestyle: 0, transparency: 100, color: "rgba(255,255,255,0)", visible: true },

            // Invisible sources for area fills
            avg_area_src:    { plottype: 7, linewidth: 0, linestyle: 0, transparency: 100, color: "#000", visible: true },
            smooth_area_src: { plottype: 7, linewidth: 0, linestyle: 0, transparency: 100, color: "#000", visible: true },

            // Invisible halo edges
            halo_top:        { plottype: 7, linewidth: 0, linestyle: 0, transparency: 100, color: "#000", visible: true },
            halo_bot:        { plottype: 7, linewidth: 0, linestyle: 0, transparency: 100, color: "#000", visible: true },

            // Invisible zone lines (only their fills show)
            zone_pos_hi:     { plottype: 7, linewidth: 0, linestyle: 0, transparency: 100, color: "#000", visible: true },
            zone_pos_lo:     { plottype: 7, linewidth: 0, linestyle: 0, transparency: 100, color: "#000", visible: true },
            zone_neg_hi:     { plottype: 7, linewidth: 0, linestyle: 0, transparency: 100, color: "#000", visible: true },
            zone_neg_lo:     { plottype: 7, linewidth: 0, linestyle: 0, transparency: 100, color: "#000", visible: true },
          },

          filledAreasStyle: {
            // Faint single-hue hazes
            fa_avg:       { color: "#35ff9e", transparency: 88, visible: true },
            fa_smooth:    { color: "#ff3b3b", transparency: 88, visible: true },

            // Cyan pulse at crossovers
            fa_halo:      { color: "#00eaff", transparency: 70, visible: true },

            // Ambient band tints (very faint)
            fa_zone_pos:  { color: "#06f598", transparency: 90, visible: true },
            fa_zone_neg:  { color: "#ee2b3b", transparency: 90, visible: true },
          },

          precision: 2,
          inputs: {}
        },

        styles: {
          avg_z_score_plot:         { title: "VVIX Avg Z-Score", histogramBase: 0, joinPoints: true },
          super_smooth_z_score_plot:{ title: "VVIX Super Smooth Z-Score", histogramBase: 0, joinPoints: true },
        },

        inputs: []
      },

      constructor: function () {
        this.init = function (ctx) {
          this._context = ctx;

          // Fetch data from Zustand store (keep your mapping & daily alignment)
          const vvixData = useStore.getState().vvixData || [];
          if (!vvixData || vvixData.length === 0) {
            this._vvixData = [];
            return;
          }

          this._vvixData = vvixData
            .map(entry => {
              const avgZScore = parseFloat(entry.vvix_avg_z_score);
              const superSmoothZScore = parseFloat(entry.vvix_super_smooth_z_score);
              if (!Number.isFinite(avgZScore) || !Number.isFinite(superSmoothZScore)) return null;

              // Use your day-resolution timestamps
              const t = Math.floor(new Date(entry.date).getTime() / 1000);
              return { time: t, avg: avgZScore, slow: superSmoothZScore };
            })
            .filter(Boolean);
        };

        this.main = function (ctx) {
          // Return order must match plots[]:
          // [avg_glow, smooth_glow, avg_line, slow_line, baseline,
          //  avg_area_src, slow_area_src, halo_top, halo_bot,
          //  zone_pos_hi, zone_pos_lo, zone_neg_hi, zone_neg_lo]
          const EMPTY = [NaN, NaN, NaN, NaN, 0, NaN, NaN, NaN, NaN, 1.0, 0.5, -0.5, -1.0];

          if (!this._vvixData || this._vvixData.length === 0) return EMPTY;

          const currentTime = Math.floor(ctx.symbol.time / 1000);
          if (!Number.isFinite(currentTime)) return EMPTY;

          // Align to day (keep your behavior)
          const day = 86400;
          const roundedCurrent = Math.floor(currentTime / day) * day;

          let closest = null, smallest = Infinity;
          for (const p of this._vvixData) {
            const rounded = Math.floor(p.time / day) * day;
            const d = Math.abs(rounded - roundedCurrent);
            if (d < smallest) { smallest = d; closest = p; }
          }
          if (!closest) return EMPTY;

          const fast = Number.isFinite(closest.avg)  ? closest.avg  : NaN;
          const slow = Number.isFinite(closest.slow) ? closest.slow : NaN;

          // Crossover halo when lines are very close
          const HALO_EPS = 0.04;
          const EPS = 1e-6;
          const near = (Number.isFinite(fast) && Number.isFinite(slow) && Math.abs(fast - slow) <= HALO_EPS);
          const haloTop = near ? Math.max(fast, slow) + EPS : NaN;
          const haloBot = near ? Math.min(fast, slow) - EPS : NaN;

          // Hazes mirror the line values
          const avgArea  = Number.isFinite(fast) ? fast : NaN;
          const slowArea = Number.isFinite(slow) ? slow : NaN;

          return [
            fast, slow,        // glows
            fast, slow,        // your two lines (IDs preserved)
            0,                 // baseline
            avgArea, slowArea, // haze
            haloTop, haloBot,  // crossover band
            1.0, 0.5,          // ambient +
            -0.5, -1.0         // ambient -
          ];
        };
      },
    },
  ]);
};



// import useStore from '../Store/market_greeks_data_store';
//
// export const customIndicatorsGetter = function (PineJS) {
//   return Promise.resolve([
//     {
//       name: 'SPX Gamma Volatility Indicator',
//       metainfo: {
//         _metainfoVersion: 53,
//         id: "SPXGammaVolatilityIndicator@tv-basicstudies-1",
//         description: "SPX Gamma Volatility Indicator",
//         shortDescription: "SPX Gamma Vol",
//         format: { type: "inherit" },
//         linkedToSeries: false,
//         is_price_study: false,
//         plots: [
//           { id: "avg_z_score_plot", type: "line" },
//           { id: "super_smooth_z_score_plot", type: "line" },
//         ],
//         defaults: {
//           styles: {
//             avg_z_score_plot: {
//               linestyle: 0,
//               linewidth: 2,
//               plottype: 0, // Line plot
//               trackPrice: false,
//               transparency: 40, // 60% opacity
//               visible: true,
//               color: "#14f602", // Green line
//             },
//             super_smooth_z_score_plot: {
//               linestyle: 0,
//               linewidth: 2,
//               plottype: 0, // Line plot
//               trackPrice: false,
//               transparency: 40, // 60% opacity
//               visible: true,
//               color: "#f10000", // Orange line
//             },
//           },
//         },
//         styles: {
//           avg_z_score_plot: { title: "VVIX Avg Z-Score", histogramBase: 0, joinPoints: true },
//           super_smooth_z_score_plot: { title: "VVIX Super Smooth Z-Score", histogramBase: 0, joinPoints: true },
//         },
//         inputs: [], // No user input needed
//       },
//       constructor: function () {
//         this.init = function (ctx) {
//           this._context = ctx;
//
//           // Fetch data from Zustand store
//           const vvixData = useStore.getState().vvixData || [];
//           if (!vvixData || vvixData.length === 0) {
//             console.error('vvixData is undefined or empty.');
//             this._vvixData = [];
//             return;
//           }
//
//           // Map `vvixData` to PineJS-compatible format
//           this._vvixData = vvixData
//             .map(entry => {
//               const avgZScore = parseFloat(entry.vvix_avg_z_score);
//               const superSmoothZScore = parseFloat(entry.vvix_super_smooth_z_score);
//               if (isNaN(avgZScore) || isNaN(superSmoothZScore)) {
//                 // console.warn(`Skipping entry with invalid scores:`, entry);
//                 return null; // Skip invalid entries
//               }
//               return {
//                 time: Math.floor(new Date(entry.date).getTime() / 1000), // Convert to Unix time in seconds
//                 avgZScore,
//                 superSmoothZScore,
//               };
//             })
//             .filter(data => data !== null); // Exclude invalid entries
//
//           // console.log('Mapped vvix data:', this._vvixData);
//         };
//         this.main = function (ctx) {
//           const currentTime = Math.floor(ctx.symbol.time / 1000); // Convert to seconds
//
//           if (!this._vvixData || this._vvixData.length === 0) {
//             return [NaN, NaN]; // Return NaN if no data is available
//           }
//
//           // Round current time to start of day (in seconds)
//           const roundedCurrentTime = Math.floor(currentTime / 86400) * 86400;
//
//           // Find the closest matching time in `_vvixData` using rounded day values
//           let closestMatch = null;
//           let smallestDiff = Infinity;
//
//           for (const data of this._vvixData) {
//             const roundedDataTime = Math.floor(data.time / 86400) * 86400;
//             const timeDiff = Math.abs(roundedDataTime - roundedCurrentTime);
//             if (timeDiff < smallestDiff) {
//               closestMatch = data;
//               smallestDiff = timeDiff;
//             }
//           }
//
//           if (closestMatch) {
//             // Return the two plot values
//             return [closestMatch.avgZScore, closestMatch.superSmoothZScore];
//           }
//
//           // console.warn(`No close match found for the current time (${currentTime}). Returning NaN.`);
//           return [NaN, NaN]; // Return NaN if no match found
//         };
//       },
//     },
//   ]);
// };







